import usTimeZones from './united-states';
import caTimeZones from './canada';
import mxTimeZones from './mexico';
import auTimeZones from './australia';
import nzTimeZones from './new-zealand';
import coTimeZones from './colombia';

export default {
  ca: caTimeZones || [],
  us: usTimeZones || [],
  mx: mxTimeZones || [],
  au: auTimeZones || [],
  nz: nzTimeZones || [],
  co: coTimeZones || [],
};
